<template>
  <div>
    <el-card>

      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="车辆外观编号" prop="waiguan_bianhao">
          <el-input v-model="addForm.bianhao" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="车辆外观" prop="waiguan_memo">
          <el-input v-model="addForm.waiguan_memo"></el-input>
        </el-form-item>
        <h3>40检查项目</h3>
        <el-form-item label="图片">
          <div style="height: 100%;">
            <picUpload ref="picUploadRef" @backPicUrl="backPicUrl" show_type="3" :picsUrl="this.pics" :key="datekey"
              max_count="10"></picUpload>
          </div>
        </el-form-item>
        <el-form-item label="图片浏览">
          <div style="height: 100%;">
            <picUpload @backPicUrl="backPicUrl" show_type="1" :picsUrl="addForm.pics" :key="datekey" max_count="10">
            </picUpload>
          </div>
        </el-form-item>
        <el-card>
          <div class="select_class">
            <div v-for="(item) in jianchaTishiList" :key="item.uid" style="width: 500px;height: 40px;">
              <div style="flex: 1;"><span style="width: 220px;height: 150px;display: inline-block;">[{{ item.xuhao }}]{{ item.name }}</span> <el-switch inactive-color="#13ce66"
                  active-color="#ff4949" :active-text="item.S1" :inactive-text="item.S0" v-model='item.value' :active-value="1"  :inactive-value="0">
                </el-switch> </div>

            </div>
          </div>
        </el-card>
      </el-form>

      <div style="text-align: center;" v-if="diaoyongType === 1">
        <el-button @click="quxiao">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>

import picUpload from '../pic_com.vue'
export default {

  components: {
    picUpload: picUpload
  },
  props: ['cheliang_uid', 'diaoyongType', 'caozuoType', 'editUid'], // diaoyongType 1 正常的界面管理调用 2 开单调用 editUid 如果有值，说明是修改
  // caozuoType 1 修改 2 显示
  data() {
    return {
      picsUid: '',
      pic_upload_url: window.sessionStorage.getItem('http_api') + '/upload',
      datekey: Date.now(),
      jianchaTishiList: [],
      addForm: {
        C_type: 'waiguan',
        bianhao: '',
        waiguan_memo: '',
        cheliang_uid: 0,
        uid: 0,
        pics: '',
        pics_one: '',
        Jiance000: 0,
        Jiance001: 0,
        Jiance002: 0,
        Jiance003: 0,
        Jiance004: 0,
        Jiance005: 0,
        Jiance006: 0,
        Jiance007: 0,
        Jiance008: 0,
        Jiance009: 0,
        Jiance010: 0,
        Jiance011: 0,
        Jiance012: 0,
        Jiance013: 0,
        Jiance014: 0,
        Jiance015: 0,
        Jiance016: 0,
        Jiance017: 0,
        Jiance018: 0,
        Jiance019: 0,
        Jiance020: 0,
        Jiance021: 0,
        Jiance022: 0,
        Jiance023: 0,
        Jiance024: 0,
        Jiance025: 0,
        Jiance026: 0,
        Jiance027: 0,
        Jiance028: 0,
        Jiance029: 0,
        Jiance030: 0,
        Jiance031: 0,
        Jiance032: 0,
        Jiance033: 0,
        Jiance034: 0,
        Jiance035: 0,
        Jiance036: 0,
        Jiance037: 0,
        Jiance038: 0,
        Jiance039: 0
        
      },
      addFormRules: {
        // waiguan_memo: [
        //   { required: true, message: '请输入车辆外观', trigger: 'blur' },
        //   { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        // ]
      },
      pics: ''

    }
  },
  created() {
    console.log(802, this.cheliang_uid)
    if (this.cheliang_uid === undefined) this.addForm.cheliang_uid = ''
    else this.addForm.cheliang_uid = this.cheliang_uid
    this.getJianchaTishiList() // 先读取所有标题信息，然后写入变量数据
    if (this.caozuoType === 1) this.getBianhao_waiguan_add() // 说明是添加
    if (this.caozuoType === 2) this.Info(this.editUid)
  },
  methods: {
    async getJianchaTishiList() {
      var queryInfo = {
        C_type: 'get_list',
        C_table_name: 'jiancha_tishi_list',
        query: '',
        pageNum: 1,
        pageSize: 100,
        qiye_uid: window.sessionStorage.getItem('qiye_uid')
      }
      const { data: res } = await this.$http.get('get_api', {
        params: queryInfo
      });
      this.jianchaTishiList = JSON.parse(res.data)[0].dataList;
      console.log(9902, this.jianchaTishiList)
    },
    backPicUrl(pics) {
      this.addForm.pics = pics
      this.pics = pics
    },
    quxiao() {
      if (this.diaoyongType === 1) this.$emit('getWaiguanclose', this.Info)
    },
    async getBianhao_waiguan_add() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 15 }
      });
      // console.log(9999, JSON.parse(res.data)[0].bianhao_l)
      // console.log(JSON.parse(res.data)[0].bianhao_s);
      this.addForm.bianhao = JSON.parse(res.data)[0].bianhao_l;
    },
    async Info(uid) {
      await this.getJianchaTishiList()
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'waiguan_info', uid: uid, C_type: 'get_info' }
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }
      this.addForm = JSON.parse(res.data)[0].data[0]
      console.log(999, this.addForm)
      this.xianshi()
    },
    xianshi() {
      // 读取数据存入数据以供显示
      console.log(this.jianchaTishiList[0])
      this.jianchaTishiList[0].value = this.addForm.Jiance000
      this.jianchaTishiList[1].value = this.addForm.Jiance001
      this.jianchaTishiList[2].value = this.addForm.Jiance002
      this.jianchaTishiList[3].value = this.addForm.Jiance003
      this.jianchaTishiList[4].value = this.addForm.Jiance004
      this.jianchaTishiList[5].value = this.addForm.Jiance005
      this.jianchaTishiList[6].value = this.addForm.Jiance006
      this.jianchaTishiList[7].value = this.addForm.Jiance007
      this.jianchaTishiList[8].value = this.addForm.Jiance008
      this.jianchaTishiList[9].value = this.addForm.Jiance009
      this.jianchaTishiList[10].value = this.addForm.Jiance010
      this.jianchaTishiList[11].value = this.addForm.Jiance011
      this.jianchaTishiList[12].value = this.addForm.Jiance012
      this.jianchaTishiList[13].value = this.addForm.Jiance013
      this.jianchaTishiList[14].value = this.addForm.Jiance014
      this.jianchaTishiList[15].value = this.addForm.Jiance015
      this.jianchaTishiList[16].value = this.addForm.Jiance016
      this.jianchaTishiList[17].value = this.addForm.Jiance017
      this.jianchaTishiList[18].value = this.addForm.Jiance018
      this.jianchaTishiList[19].value = this.addForm.Jiance019
      this.jianchaTishiList[20].value = this.addForm.Jiance020
      this.jianchaTishiList[21].value = this.addForm.Jiance021
      this.jianchaTishiList[22].value = this.addForm.Jiance022
      this.jianchaTishiList[23].value = this.addForm.Jiance023
      this.jianchaTishiList[24].value = this.addForm.Jiance024
      this.jianchaTishiList[25].value = this.addForm.Jiance025
      this.jianchaTishiList[26].value = this.addForm.Jiance026
      this.jianchaTishiList[27].value = this.addForm.Jiance027
      this.jianchaTishiList[28].value = this.addForm.Jiance028
      this.jianchaTishiList[29].value = this.addForm.Jiance029
      this.jianchaTishiList[30].value = this.addForm.Jiance030
      this.jianchaTishiList[31].value = this.addForm.Jiance031
      this.jianchaTishiList[32].value = this.addForm.Jiance032
      this.jianchaTishiList[33].value = this.addForm.Jiance033
      this.jianchaTishiList[34].value = this.addForm.Jiance034
      this.jianchaTishiList[35].value = this.addForm.Jiance035
      this.jianchaTishiList[36].value = this.addForm.Jiance036
      this.jianchaTishiList[37].value = this.addForm.Jiance037
      this.jianchaTishiList[38].value = this.addForm.Jiance038
      this.jianchaTishiList[39].value = this.addForm.Jiance039
    },
    add(callback) {
      var errFlag = 0
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
          errFlag = 1
          var data = {}
          console.log('外观添加出错', errFlag, this.diaoyongType)
          if (this.diaoyongType === 2) callback(errFlag, data)
          return 1;
        }
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        // var jianchaList = []
        // this.jianchaTishiList.forEach((item, index) => {
        //   jianchaList[index] = item.value
        // })
        var Info = {
          C_type: 'waiguan',
          bianhao: this.addForm.bianhao,
          waiguan_memo: this.addForm.waiguan_memo,
          cheliang_uid: this.addForm.cheliang_uid,
          order_uid: 0,
          uid: this.editUid,
          type: this.caozuoType,
          pics: this.addForm.pics,
          pics_one: '',
          Jiance000: this.jianchaTishiList[0].value,
          Jiance001: this.jianchaTishiList[1].value,
          Jiance002: this.jianchaTishiList[2].value,
          Jiance003: this.jianchaTishiList[3].value,
          Jiance004: this.jianchaTishiList[4].value,
          Jiance005: this.jianchaTishiList[5].value,
          Jiance006: this.jianchaTishiList[6].value,
          Jiance007: this.jianchaTishiList[7].value,
          Jiance008: this.jianchaTishiList[8].value,
          Jiance009: this.jianchaTishiList[9].value,
          Jiance010: this.jianchaTishiList[10].value,
          Jiance011: this.jianchaTishiList[11].value,
          Jiance012: this.jianchaTishiList[12].value,
          Jiance013: this.jianchaTishiList[13].value,
          Jiance014: this.jianchaTishiList[14].value,
          Jiance015: this.jianchaTishiList[15].value,
          Jiance016: this.jianchaTishiList[16].value,
          Jiance017: this.jianchaTishiList[17].value,
          Jiance018: this.jianchaTishiList[18].value,
          Jiance019: this.jianchaTishiList[19].value,
          Jiance020: this.jianchaTishiList[20].value,
          Jiance021: this.jianchaTishiList[21].value,
          Jiance022: this.jianchaTishiList[22].value,
          Jiance023: this.jianchaTishiList[23].value,
          Jiance024: this.jianchaTishiList[24].value,
          Jiance025: this.jianchaTishiList[25].value,
          Jiance026: this.jianchaTishiList[26].value,
          Jiance027: this.jianchaTishiList[27].value,
          Jiance028: this.jianchaTishiList[28].value,
          Jiance029: this.jianchaTishiList[29].value,
          Jiance030: this.jianchaTishiList[30].value,
          Jiance031: this.jianchaTishiList[31].value,
          Jiance032: this.jianchaTishiList[32].value,
          Jiance033: this.jianchaTishiList[33].value,
          Jiance034: this.jianchaTishiList[34].value,
          Jiance035: this.jianchaTishiList[35].value,
          Jiance036: this.jianchaTishiList[36].value,
          Jiance037: this.jianchaTishiList[37].value,
          Jiance038: this.jianchaTishiList[38].value,
          Jiance039: this.jianchaTishiList[39].value
           
        }
        if (this.addForm.bianhao.length === 0) {
          this.$message.error('无编号，请重新递交');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          return
        }
        const { data: res } = await this.$http.post('api', Info)
        // console.log(90, JSON.parse(res.data)[0].status)
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.success('车辆外观重复！');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          return
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.success('添加出错');
          errFlag = 1
          callback(errFlag, Info) // 返回错误 uid 为 0
          return
        }
        if (JSON.parse(res.data)[0].status === 200) this.$message.success('操作成功！');
        if (this.caozuoType === 1) Info.uid = JSON.parse(res.data)[0].waiguan_uid
        if (this.diaoyongType === 1) this.$emit('getWaiguanNewUid', Info)
        if (this.diaoyongType === 2) callback(errFlag, Info)
      });
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    }
  }
}
</script>

<style>
.select_class {
  display: flex;
  flex-wrap: wrap;
  /* flex-direction: column; */
  justify-content: space-around;
  gap: 10px;
}
</style>
